// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module__container___1POy3","cover":"style-module__cover___14UFh","coverContainer":"style-module__coverContainer___kJt16","logo":"style-module__logo___nY6f2"};